export default "__VITE_ASSET__Cnkq1gjP__"